import { ResizableProvider } from "@platejs/resizable";
import { PlateElement, withHOC } from "@platejs/core/react";
import { Image, useMediaState } from "@platejs/media/react";
import { withRef } from "@udecode/cn";

export const ImageElement = withHOC(
	ResizableProvider,
	withRef<typeof PlateElement>(({ children, className, ...props }, ref) => {
		// const { align = "center", focused, readOnly, selected } = useMediaState();
		return (
			<PlateElement {...props} ref={ref}>
				<Image />
				{children}
			</PlateElement>
		);
	})
);
